import { z } from "zod";

const AddressType = z.enum(["businessAddress"]);

export const Request = z.object({
  entityIds: z
    .string()
    .transform((val) => val.split(","))
    .pipe(z.string().array().min(1)),
  addressType: AddressType,
});

export type Request = z.infer<typeof Request>;
